<template>
  <div class="privacy-page py-7">
    <div class="container">
      <h1 class="display-5 fw-bold mb-4">Privacy Policy</h1>

      <div class="content">
        <!-- Data di ultimo aggiornamento -->
        <p class="text-muted mb-4">Ultimo aggiornamento: {{ new Date().toLocaleDateString('it-IT') }}</p>

        <section class="mb-5">
          <h2 class="h4 mb-3">1. Introduzione</h2>
          <p>La presente Privacy Policy è redatta ai sensi dell'art. 13 del Regolamento UE 2016/679 (GDPR) e fornisce informazioni dettagliate sul trattamento dei dati personali effettuato attraverso il sito web ImmobilAutoFVG.</p>
        </section>

        <section class="mb-5">
          <h2 class="h4 mb-3">2. Titolare del Trattamento</h2>
          <p>ImmobilAutoFVG S.r.l.</p>
          <p>Sede legale: Via Udine, 123 - 33100 Udine (UD)</p>
          <p>P.IVA: IT12345678901</p>
          <p>Email: privacy@immobilautoFVG.it</p>
          <p>PEC: immobilautoFVG@pec.it</p>
          <p>Tel: +39 0432 123456</p>
        </section>

        <section class="mb-5">
          <h2 class="h4 mb-3">3. Responsabile della Protezione dei Dati (DPO)</h2>
          <p>Il DPO può essere contattato all'indirizzo: dpo@immobilautoFVG.it</p>
        </section>

        <section class="mb-5">
          <h2 class="h4 mb-3">4. Categorie di Dati Trattati</h2>
          <ul class="list-unstyled">
            <li class="mb-4">
              <strong>4.1 Dati di navigazione:</strong>
              <p>I sistemi informatici acquisiscono automaticamente:</p>
              <ul>
                <li>Indirizzo IP</li>
                <li>Data e orario di accesso</li>
                <li>Pagine visitate</li>
                <li>Browser e sistema operativo utilizzati</li>
              </ul>
            </li>
            <li class="mb-4">
              <strong>4.2 Dati forniti volontariamente:</strong>
              <ul>
                <li>Dati anagrafici (nome, cognome)</li>
                <li>Dati di contatto (email, telefono)</li>
                <li>Dati aziendali (ragione sociale, P.IVA)</li>
              </ul>
            </li>
          </ul>
        </section>

        <section class="mb-5">
          <h2 class="h4 mb-3">5. Finalità e Base Giuridica</h2>
          <ul class="list-unstyled">
            <li class="mb-3">
              <strong>5.1 Esecuzione del contratto (Art. 6.1.b GDPR):</strong>
              <ul>
                <li>Gestione richieste di informazioni</li>
                <li>Fornitura dei servizi richiesti</li>
              </ul>
            </li>
            <li class="mb-3">
              <strong>5.2 Consenso (Art. 6.1.a GDPR):</strong>
              <ul>
                <li>Marketing diretto</li>
                <li>Newsletter</li>
              </ul>
            </li>
            <li class="mb-3">
              <strong>5.3 Obbligo legale (Art. 6.1.c GDPR):</strong>
              <ul>
                <li>Adempimenti fiscali</li>
                <li>Conservazione documenti</li>
              </ul>
            </li>
          </ul>
        </section>

        <section class="mb-5">
          <h2 class="h4 mb-3">6. Destinatari dei Dati</h2>
          <p>I dati potranno essere comunicati a:</p>
          <ul>
            <li>Fornitori di servizi IT</li>
            <li>Consulenti legali e fiscali</li>
            <li>Autorità competenti</li>
          </ul>
        </section>

        <section class="mb-5">
          <h2 class="h4 mb-3">7. Trasferimento Extra UE</h2>
          <p>Non è previsto alcun trasferimento di dati personali verso Paesi terzi extra UE.</p>
        </section>

        <section class="mb-5">
          <h2 class="h4 mb-3">8. Periodo di Conservazione</h2>
          <ul>
            <li>Dati di navigazione: 12 mesi</li>
            <li>Dati per marketing: fino a revoca del consenso</li>
            <li>Dati contrattuali: 10 anni dalla cessazione del rapporto</li>
          </ul>
        </section>

        <section class="mb-5">
          <h2 class="h4 mb-3">9. Diritti dell'Interessato</h2>
          <p>L'interessato può esercitare i seguenti diritti:</p>
          <ul>
            <li>Accesso (Art. 15 GDPR)</li>
            <li>Rettifica (Art. 16 GDPR)</li>
            <li>Cancellazione (Art. 17 GDPR)</li>
            <li>Limitazione (Art. 18 GDPR)</li>
            <li>Portabilità (Art. 20 GDPR)</li>
            <li>Opposizione (Art. 21 GDPR)</li>
          </ul>
          <p>Per esercitare i propri diritti: privacy@immobilautoFVG.it</p>
        </section>

        <section class="mb-5">
          <h2 class="h4 mb-3">10. Reclamo</h2>
          <p>È possibile proporre reclamo all'Autorità Garante per la protezione dei dati personali: www.garanteprivacy.it</p>
        </section>
      </div>
    </div>
  </div>
</template>

<style scoped>
.privacy-page {
  background: rgba(142, 202, 230, 0.1);
}

.content {
  max-width: 800px;
  margin: 0 auto;
}

h2 {
  color: #219ebc;
}

p {
  color: #666;
  line-height: 1.6;
}

strong {
  color: #023047;
}
</style>
